import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import AuthEngine from '@/plugins/msal'
import ShopRevenueInput from './views/ShopRevenueInput.vue'
import HomePage from './views/HomePage.vue'
import AuthCallback from './components/AuthCallback.vue'
import ContactUs from './views/ContactUs.vue'
import MemberAddUpdate from './views/Admin/MemberAddUpdate.vue'
import ShopAdministration from './views/Admin/ShopAdministration.vue'
import ShopAdministrationEdit from './views/Admin/ShopAdministrationEdit.vue'
import RevenueResponseModal from './components/revenueResponse/RevenueResponseModal.vue'
import MemberAdministration from './views/Admin/MemberAdministration.vue'
import NotificationGroupAdministration from './views/Admin/NotificationGroupAdministration.vue'
import NotificationGroupsUpdate from './views/Admin/NotificationGroupsUpdate.vue'
import ChainAdministration from './views/Admin/ChainAdministration.vue'
import ChainAdministrationEdit from './views/Admin/ChainAdministrationEdit.vue'
import TermsAndConditions from './views/TermsAndConditions.vue'
import SectionAdministration from './views/Admin/SectionAdministration.vue'
import SectionsAdministrationEdit from './views/Admin/SectionsAdministrationEdit.vue'

type AdminEditRouteLike = {
  params: {
    id?: unknown
  }
  query: {
    returnTo?: unknown
  }
}

type AdminEditProps = {
  id: number
  returnTo?: string
}

function mapAdminEditProps(route: AdminEditRouteLike): AdminEditProps {
  return {
    id: parseInt(String(route.params.id), 10),
    returnTo: route.query.returnTo as string | undefined,
  }
}

function memberAdminEditProps(route: AdminEditRouteLike): AdminEditProps {
  return mapAdminEditProps(route)
}

function groupAdminEditProps(route: AdminEditRouteLike): AdminEditProps {
  return mapAdminEditProps(route)
}

function shopAdminEditProps(route: AdminEditRouteLike): AdminEditProps {
  return mapAdminEditProps(route)
}

function chainAdminEditProps(route: any): { id: number; returnTo: string } {
  return { id: parseInt(route.params.id), returnTo: route.query.returnTo as string }
}

function sectionAdminEditProps(route: any): { id: number; returnTo: string } {
  return { id: parseInt(route.params.id), returnTo: route.query.returnTo as string }
}

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'homepage',
    component: HomePage,
  },
  {
    path: '/login',
    name: 'login',
    component: HomePage,
  },
  {
    path: '/shops',
    name: 'shopRevenue',
    component: ShopRevenueInput,
    meta: {
      authorize: true,
    },
  },
  {
    path: '/contactus',
    component: ContactUs,
  },
  {
    path: '/callback',
    name: 'callback',
    component: AuthCallback,
  },
  {
    path: '/shops/submitSummary',
    name: 'submitSummary',
    component: RevenueResponseModal,
    props: true,
    meta: {
      authorize: true,
    },
  },
  {
    path: '/shops/admin',
    name: 'shopAdmin',
    component: ShopAdministration,
    meta: {
      authorize: true,
    },
  },
  {
    path: '/shops/admin/edit/:id',
    name: 'shopAdminEdit',
    component: ShopAdministrationEdit,
    props: shopAdminEditProps,
    meta: {
      authorize: true,
    },
  },
  {
    path: '/shops/admin/create',
    name: 'shopAdminCreate',
    component: ShopAdministrationEdit,
    meta: {
      authorize: true,
    },
  },
  {
    path: '/members/admin',
    name: 'memberAdmin',
    component: MemberAdministration,
    meta: {
      authorize: true,
    },
  },
  {
    path: '/members/admin/edit/:id',
    name: 'memberAdminEdit',
    component: MemberAddUpdate,
    props: memberAdminEditProps,
    meta: {
      authorize: true,
    },
  },
  {
    path: '/members/admin/create',
    name: 'memberAdminCreate',
    component: MemberAddUpdate,
    meta: {
      authorize: true,
    },
  },
  {
    path: '/notificationGroup/admin',
    name: 'notificationGroupAdmin',
    component: NotificationGroupAdministration,
    meta: {
      authorize: true,
    },
  },
  {
    path: '/notificationGroup/admin/edit/:id',
    name: 'notificationGroupAdminEdit',
    component: NotificationGroupsUpdate,
    props: groupAdminEditProps,
    meta: {
      authorize: true,
    },
  },
  {
    path: '/tandc',
    name: 'termsAndConditions',
    component: TermsAndConditions,
  },
  {
    path: '/chains/admin',
    name: 'ChainAdministration',
    component: ChainAdministration,
    meta: {
      authorize: true,
    },
  },
  {
    path: '/chains/admin/edit/:id',
    name: 'ChainAdministrationEdit',
    component: ChainAdministrationEdit,
    props: chainAdminEditProps,
    meta: {
      authorize: true,
    },
  },
  {
    path: '/chains/admin/create',
    name: 'ChainAdministrationCreate',
    component: ChainAdministrationEdit,
    meta: {
      authorize: true,
    },
  },
  {
    path: '/sections/admin',
    name: 'SectionsAdministration',
    component: SectionAdministration,
    meta: {
      authorize: true,
    },
  },
  {
    path: '/sections/admin/edit/:id',
    name: 'SectionsAdministrationEdit',
    component: SectionsAdministrationEdit,
    props: sectionAdminEditProps,
    meta: {
      authorize: true,
    },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, _from, next) => {
  if (to.matched.some((record) => record.meta?.authorize) && !AuthEngine.isAuthenticated()) {
    next({
      path: '/login',
      query: { target: to.fullPath },
    })
  } else {
    next()
  }
})

export default router
